export const actionTypes = {
  ADD_OFFICE_SUCCESS: "ADD_OFFICE_SUCCESS",
  LOADING: "LOADING",
  OFFICES_LOADING: "OFFICES_LOADING",
  SET_OFFICES: "SET_OFFICES",
  SET_OFFICE_SELECTED: "SET_OFFICE_SELECTED",
  REMOVE_OFFICE_SELECTED: "REMOVE_OFFICE_SELECTED",
  CLEAR_OFFICE_ERRORS: "CLEAR_OFFICE_ERRORS",
  GET_COUNTRIES: "GET_COUNTRIES",
  GET_STATES: 'GET_STATES',
  GET_BUSINESS_DAYS_PRESETS: 'GET_BUSINESS_DAYS_PRESETS',
  GET_OFFICE_BUSINESS_DAYS: 'GET_OFFICE_BUSINESS_DAYS',
  SET_OFFICE_FOR_EDIT: 'SET_OFFICE_FOR_EDIT',
  CLEAR_OFFICE_FOR_EDIT: 'CLEAR_OFFICE_FOR_EDIT',
  DELETE_OFFICE: 'DELETE_OFFICE',
  INCREMENT_OFFICE_USER_COUNT: 'INCREMENT_OFFICE_USER_COUNT',
};
